export default function initTableBars() {
  const config = (color, height) => ({
    chart: {
      toolbar: {
        show: false,
      },
      height,
      width: '100%',
      type: 'area',
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
    },
    colors: [color],
    fill: {
      colors: [color],
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.53,
        opacityTo: 0,
        stops: [0, 100],
      },
    },
    tooltip: {
      enabled: false,
    },
    series: [{
      name: 'Task',
    }],
    grid: {
      show: false,
      padding: {
        left: 0,
        right: 0,
      },
    },
    legend: {
      show: false,
    },
    yaxis: {
      show: false,
      floating: true,
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        show: false,
      },
    },
    xaxis: {
      show: false,
      floating: true,
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
      },
    },
    responsive: [
      {
        breakpoint: 767,
        options: {
          chart: {
            height: 60,
          },
        },
      },
    ],
  });

  let graphHeight;
  switch ($('#period').val()) {
    case '7 d':
      graphHeight = 75;
      break;
    case undefined:
      graphHeight = 60;
      break;
    default:
      graphHeight = 70;
      break;
  }

  $('.table-bar').each((ind, elem) => {
    const $bar = $(elem);
    const weekStatistics = $bar.text().trim().split(',');
    const graphColor = $bar.data('graph_active') ? '#02C3B5' : '#FF7672';

    const options = {
      ...config(graphColor, graphHeight),
      ...{
        series: [{
          data: weekStatistics,
        }],
      },
    };


    const observerCallback = (entries, observer) => {
      if (!entries[0].isIntersecting) {
        return;
      }

      const chart = new ApexCharts($bar.parent()[0], options);
      chart.render();
      observer.disconnect();
    };

    setTimeout(() => {
      const observer = new IntersectionObserver(observerCallback, { threshold: 0.1 });
      observer.observe(elem.parentElement);
    }, 2000);
  });
}
